// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lsqqp","bullet":"styles_bullet__XugOO"};